import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";

const BoardofdirectDetails = () => {
  const meta = metaConfig.directorsdetails;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 230, behavior: "smooth" });
    }, 100); // Delay allows DOM to settle
  }, []);

  const location = useLocation(); // Initialize location first
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const {
    memberName = "",
    organizationName = "",
    imageUrl = "",
    designation = "",
    energyTitle = "",
    energySubTitle = "",
    energyDescription = "",
    encourageTitle = "",
    encourageSubTitle = "",
    encourageDescription = "",
    engagedTitle = "",
    engagedSubTitle = "",
    engagedDescription = "",
  } = location.state || {};
  return (
    <div className="board_details">
      <SEO {...meta} />
      <div>
        <div className="container-fluid  ktig_services_page position-relative p-0">
          <div className="w-100 me-3 top_head">
            <div className="top_head align-items-center"></div>
          </div>
          <Header />
        </div>

        <div class="container-fluid boardmember_bread bg-breadcrumb">
          <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
            <ol
              class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
              data-wow-delay="0.3s"
            ></ol>
            <h4
              class="text-white display-4 mb-4 wow fadeInDown"
              data-wow-delay="0.1s"
            >
              Behind the Lens: The Director's Story
            </h4>
          </div>
        </div>

        <div
          className="modal fade"
          id="searchModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content rounded-0">
              <div className="modal-header">
                <h4 className="modal-title mb-0" id="exampleModalLabel">
                  Search by keyword
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body d-flex align-items-center">
                <div className="input-group w-75 mx-auto d-flex">
                  <input
                    type="search"
                    className="form-control p-3"
                    placeholder="keywords"
                    aria-describedby="search-icon-1"
                  />
                  <span
                    id="search-icon-1"
                    className="input-group-text btn border p-3"
                  >
                    <i className="fa fa-search text-white"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid innercontain py-5 ktig_services_page directs_details overflow-hidden">
          <div className="container pt-3 ">
            <div className="row directors_inner">
              <div
                className="col-lg-5 p-0 mt-0 ktig_lp wow fadeInLeft"
                data-wow-delay="0.2s"
              >
                <div className="about-img w-100 directors_photo">
                  <img
                    src={imageUrl}
                    alt="image"
                    className="img-fluid w-100"
                    // alt="Director"
                  />
                </div>
              </div>

              <div
                className="col-lg-7 mt-0 directors_title wow fadeInRight"
                data-wow-delay="0.2s"
              >
                <div className="about-item my-auto">
                  <h3 className="mb-4 text-white">{memberName}</h3>

                  <p className="text-white designation_text pt-3">
                    {designation}
                  </p>
                  <p className="text-white  companynames pt-3">
                    {organizationName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overlaygradient pb-5 mb-5 ktig_services_page  container-fluid">
          <div className="container py-6">
            <div
              className="col-10 text-left  mx-auto pb-2 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h3 className="text-white success_title mb-3">
                Awards and Recognition
              </h3>
              <a className="backtopboard" href="/board-of-directories">
                <i class="fa fa-arrow-right pe-2"></i> Back to Board
              </a>
            </div>

            <div
              className="col-lg-10  col-xl-10 m-auto wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div className="service-item rounded p-4 mb-4">
                <div className="d-flex">
                  <div className="pe-3">
                    <div className="service-btn details_board_title">
                      <p>Energy</p>
                    </div>
                  </div>
                  <div>
                    <a
                      href="/kovai-tech-member-chamber"
                      className="h5 text-white d-inline-block mb-2"
                    >
                      {energyTitle}
                    </a>
                    <p className="small_caption">{energySubTitle}</p>
                    <p className="mb-0 text-white">{energyDescription}</p>
                  </div>
                </div>
              </div>
              <div className="service-item rounded p-4 mb-4">
                <div className="d-flex">
                  <div className="pe-3">
                    <div className="service-btn  details_board_title">
                      <p>Encourage</p>
                    </div>
                  </div>
                  <div>
                    <a
                      href="https://cogniitec.com"
                      className="h5 text-white d-inline-block mb-2"
                    >
                      {encourageTitle}
                    </a>
                    <p className="small_caption">{encourageSubTitle}</p>
                    <p className="mb-0 text-white">{encourageDescription}</p>
                  </div>
                </div>
              </div>
              <div className="service-item rounded p-4 mb-0">
                <div className="d-flex">
                  <div className="pe-3">
                    <div className="service-btn  details_board_title">
                      <p>Engaged</p>
                    </div>
                  </div>
                  <div>
                    <a
                      href="https://www.bracadmy.com/"
                      className="h5 text-white d-inline-block mb-2"
                    >
                      {engagedTitle}
                    </a>
                    <p className="small_caption">{engagedSubTitle}</p>
                    <p className="mb-0 text-white">{engagedDescription}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <button
          className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
          onClick={() => window.scrollTo(0, 0)}
        >
          <i className="fa fa-arrow-up"></i>
        </button>
      </div>
    </div>
  );
};

export default BoardofdirectDetails;
